export interface FieldWorkerSettings {
  is_field_worker: boolean;
  show_last_known_location: boolean;
  enable_smart_clock_integration: boolean;
  auto_present_jobs_on_clock_in: boolean;
  auto_checkout_jobs_on_clock_out: boolean;
}

export const DEFAULT_FIELD_WORKER_SETTINGS: FieldWorkerSettings = {
  is_field_worker: false,
  show_last_known_location: false,
  enable_smart_clock_integration: false,
  auto_present_jobs_on_clock_in: true,
  auto_checkout_jobs_on_clock_out: true,
};
